import { GetterTree } from 'vuex';
import { UsersState, RootState } from '../types';

export const getters: GetterTree<UsersState, RootState> = {
	getUsers(state): Auth0User[] {
		return state.users;
	},

	getCount(state): number {
		return state.count;
	}
};
